<template>
    <div>
        <v-container fluid>
            <v-toolbar dense dark color="secondary" class="white--text">
                <v-spacer></v-spacer>
                <v-toolbar-title>
                    Transacting
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="dashboard" dark icon @click="$emit('close')"><v-icon>mdi-arrow-left</v-icon></v-btn>
                <v-btn v-else dark icon :to="$store.state.analytics.return"><v-icon>mdi-arrow-left</v-icon></v-btn>
            </v-toolbar>
            <v-card class="pb-2">
                <v-container grid-list-xs fluid>
                    <v-container grid-list-xs fluid>
                        <v-row class="margin-top:0px;padding-top:0px;">
                            <v-col
                                cols="5"
                                class="margin-top:0px;padding-top:0px;"
                            >
                                <v-toolbar
                                    height="30"
                                    color="primary"
                                    dense
                                    style="color: #fff;"
                                >
                                    Details
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <table class="tbl-trs">
                                    <thead>
                                        <tr>
                                            <th>ShiftDetail</th>
                                            <th>ShiftDate</th>
                                            <th>Shift</th>
                                            <th>Truck</th>
                                            <th>Trailer</th>
                                            <th>ReplacementUnit</th>
                                            <th>Yard</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-center">
                                                {{
                                                    ShiftDetail[0][
                                                        'ShiftDetail'
                                                    ]
                                                }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].ShiftDate }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].Shift }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].Truck }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].Trailer }}
                                            </td>
                                            <td class="text-center">
                                                {{
                                                    ShiftDetail[0]
                                                        .ReplacementUnit
                                                }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].Yard }}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th colspan="2">Driver</th>
                                            <th colspan="1">
                                                ShiftStartTime
                                            </th>
                                            <th colspan="1">
                                                ShiftEndTime
                                            </th>
                                            <th>Odomer Total</th>
                                            <th colspan="2">
                                                Paper Work Origin
                                            </th>
                                        </tr>
                                        <tr>
                                            <td class="text-center" colspan="2">
                                                {{ ShiftDetail[0].Driver }}
                                            </td>
                                            <td class="text-center" colspan="1">
                                                {{
                                                    ShiftDetail[0]
                                                        .ShiftStartTime
                                                }}
                                            </td>
                                            <td class="text-center" colspan="1">
                                                {{
                                                    ShiftDetail[0].ShiftEndTime
                                                }}
                                            </td>
                                            <td class="text-center">
                                                {{ ShiftDetail[0].OdoStart }}
                                            </td>
                                            <td class="text-center" colspan="2">
                                                {{
                                                    ShiftDetail[0][
                                                        'PaperworkOrigin'
                                                    ]
                                                }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- <v-simple-table dense class="tableTrasac">
                                    <tbody>
                                        <tr v-if="subMenu == 1">
                                            <th>ShiftDetail</th>
                                            <th>ShiftDate</th>
                                            <th>Shift</th>
                                            <th>Truck</th>
                                            <th>Trailer</th>
                                            <th>ReplacementUnit</th>
                                            <th>Yard</th>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <td>
                                                {{
                                                    ShiftDetail[0][
                                                        'ShiftDetail'
                                                    ]
                                                }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].ShiftDate }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Shift }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Truck }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Trailer }}
                                            </td>
                                            <td>
                                                {{
                                                    ShiftDetail[0]
                                                        .ReplacementUnit
                                                }}
                                            </td>
                                            <td>
                                                {{ ShiftDetail[0].Yard }}
                                            </td>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <th colspan="3">Driver</th>
                                            <th colspan="2">
                                                ShiftStartTime
                                            </th>
                                            <th colspan="2">
                                                ShiftEndTime
                                            </th>
                                        </tr>
                                        <tr v-if="subMenu == 1">
                                            <td colspan="2">
                                                {{ ShiftDetail[0].Driver }}
                                            </td>
                                            <td colspan="2">
                                                {{
                                                    ShiftDetail[0]
                                                        .ShiftStartTime
                                                }}
                                            </td>
                                            <td colspan="2">
                                                {{
                                                    ShiftDetail[0].ShiftEndTime
                                                }}
                                            </td>
                                        </tr>

                                        <tr v-if="subMenu == 2">
                                            <th>Total Revenue</th>
                                            <th>Total Payroll</th>
                                            <th>Total Extra Revenue</th>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <td>{{ totalRev }}</td>
                                            <td>{{ totalPay }}</td>
                                            <td>{{ totalExtraRev }}</td>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <th>Total Extra Payroll</th>
                                            <th>Net</th>
                                            <th>Margin</th>
                                        </tr>
                                        <tr v-if="subMenu == 2">
                                            <td>{{ totalExtraPay }}</td>
                                            <td>{{ net }}</td>
                                            <td>{{ margin }}</td>
                                        </tr>
                                        <tr v-if="subMenu == 3">
                                            <td width="80%">
                                                <v-textarea
                                                    class="tdTransc mt-2"
                                                    label="Comments"
                                                    rows="3"
                                                    outlined
                                                    hide-details
                                                    dense
                                                    v-model="
                                                        ShiftDetail[0]
                                                            .AdmComments
                                                    "
                                                    append-icon="mdi-content-save"
                                                    @click:append="
                                                        saveMore(ShiftDetail[0])
                                                    "
                                                ></v-textarea>
                                            </td>
                                           
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <th width="20%">
                                                OutofProvOdo Start
                                            </th>
                                            <th width="20%">Repl Odo Start</th>
                                            <th width="20%">Odo Start</th>
                                            <th width="20%">
                                                Paperwork Origin
                                            </th>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <td>
                                                {{ ShiftDetail[0]
                                                            .OutofProvOdoStart}}
                                            </td>
                                            <td>
                                                {{ShiftDetail[0]
                                                            .ReplUnitOdoStart}}
                                            </td>
                                            <td>
                                                {{ShiftDetail[0].OdoStart}}
                                            </td>
                                            <td>
                                               {{ ShiftDetail[0][
                                                            'PaperworkOrigin'
                                                        ]}}
                                            </td>
                                           
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <th>OutofProvOdo End</th>
                                            <th>Repl Odo End</th>
                                            <th>Odo End</th>
                                            <th colspan="2">Odo Total</th>
                                        </tr>
                                        <tr v-if="subMenu == 4">
                                            <td>
                                                {{ShiftDetail[0]
                                                            .OutofProvOdoEnd}}
                                            </td>
                                            <td>
                                                {{
                                                        ShiftDetail[0]
                                                            .ReplUnitOdoEnd}}
                                            </td>
                                            <td>
                                                {{
                                                        ShiftDetail[0].OdoEnd}}
                                            </td>
                                            <td>{{
                                                
                                                        ShiftDetail[0].OdoTotal}}
                                            </td>
                                           
                                        </tr>
                                    </tbody>
                                </v-simple-table> -->
                            </v-col>
                            <v-col
                                cols="2"
                                class="margin-top:0px;padding-top:0px;"
                            >
                                <v-toolbar
                                    height="30"
                                    color="primary"
                                    dense
                                    style="color: #fff;"
                                >
                                    Totals
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <table class="tbl-trs">
                                    <tr>
                                        <th>Revenue</th>
                                        <th>Payroll</th>
                                        <th>Extra Revenue</th>
                                    </tr>
                                    <tr>
                                        <td class="text-center">
                                            {{ totalRev }}
                                        </td>
                                        <td class="text-center">
                                            {{ totalPay }}
                                        </td>
                                        <td class="text-center">
                                            {{ totalExtraRev }}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>Extra Payroll</th>
                                        <th>Net</th>
                                        <th>Margin</th>
                                    </tr>
                                    <tr>
                                        <td class="text-center">
                                            {{ totalExtraPay }}
                                        </td>
                                        <td class="text-center">{{ net }}</td>
                                        <td class="text-center">
                                            {{
                                                Number(margin * 100).toFixed(2)
                                            }}
                                            %
                                        </td>
                                    </tr>
                                </table>
                            </v-col>
                            <v-col cols="2">
                                <v-textarea
                                    label="Comment Margin"
                                    textarea
                                    hide-details
                                    v-model="marginComment"
                                    name="input-7-4"
                                    solo
                                    @click:append="saveComment"
                                    append-icon="mdi-content-save"
                                    rows="4"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="3">
                                <v-toolbar
                                    height="30"
                                    color="primary"
                                    dense
                                    style="color: #fff;"
                                >
                                    Products
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <v-progress-linear
                                    size="large"
                                    indeterminate
                                    color="primary"
                                    v-if="progress"
                                ></v-progress-linear>
                                <table class="tbl-trs">
                                    <thead>
                                        <tr>
                                            <th>Order #</th>
                                            <th>Product</th>
                                            <th>Tmp Qty</th>
                                            <th>GRS Qty</th>
                                            <th>Adj Qty</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <template v-for="(prd, i) in products">
                                            <tr
                                                :key="i"
                                                style="text-align: center;"
                                            >
                                                <td>{{ prd.OrderID }}</td>
                                                <td>{{ prd.Product }}</td>
                                                <td>
                                                    {{ prd.DispatchedQuantity }}
                                                </td>
                                                <td>
                                                    {{ prd.DeliveredQuantity }}
                                                </td>
                                                <td>
                                                    {{ prd.TempAdjQuantity }}
                                                </td>
                                            </tr>
                                        </template>
                                    </tbody>
                                </table>
                            </v-col>
                        </v-row>
                        <!--Table Transact By Shift  327221-->
                        <v-row>
                            <v-col
                                cols="12"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    height="30"
                                    dense
                                    dark
                                    >Transact By Shift</v-toolbar
                                >
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in orderHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(ord, i) in orders"
                                            >
                                                <tr
                                                    :key="i"
                                                    @click="
                                                        loadOrderDetails(
                                                            ord.OrderID
                                                        )
                                                    "
                                                >
                                                    <td></td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.LoadNum }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.LoadNumOrd }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.OrderID }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ ord.BOL }}
                                                    </td>
                                                    <td>{{ ord.Customer }}</td>
                                                    <td>{{ ord.Terminal }}</td>
                                                    <td>{{ ord.Station }}</td>
                                                    <td>
                                                        {{ ord.PreloadOrderID }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </v-col>
                        </v-row>
                        <!--Table Revenue and PayRoll-->
                        <v-row>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px;"
                            >
                                <v-toolbar
                                    color="primary"
                                    height="30"
                                    dense
                                    dark
                                    >Revenue
                                </v-toolbar>
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm, i) in revTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Quantity }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Rate }}
                                                    </td>
                                                    <td>
                                                        {{ itm.Amount }}
                                                    </td>
                                                    <td>
                                                        {{ itm.InvId }}
                                                    </td>
                                                    <td
                                                        width="3%"
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="primary"
                                                            dark
                                                            @click="
                                                                openRates(itm)
                                                            "
                                                            >mdi-book-open</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Rev *
                                        <v-chip class="divs" label value>
                                            {{ totalRev }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar color="primary" dense dark
                                    >PayRoll
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transPayHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm, i) in payTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Quantity }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Rate }}
                                                    </td>
                                                    <td>
                                                        {{ itm.Amount }}
                                                    </td>
                                                    <td>
                                                        {{ itm.PayId }}
                                                    </td>
                                                    <td
                                                        width="3%"
                                                        style="text-align:center"
                                                    >
                                                        <v-icon
                                                            x-small
                                                            class="mx-3"
                                                            color="primary"
                                                            dark
                                                            @click="
                                                                openRates(itm)
                                                            "
                                                            >mdi-book-open</v-icon
                                                        >
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Payroll *
                                        <v-chip class="divs" label value>
                                            {{ totalPay }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <!--Table Extra Revenue and  Extra PayRoll-->
                        <v-row>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    dense
                                    dark
                                    height="30"
                                    >Extra Revenue
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm,
                                                i) in extraRevTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Quantity }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Rate }}
                                                    </td>
                                                    <td>
                                                        {{ itm.Amount }}
                                                    </td>
                                                    <td>
                                                        {{ itm.InvId }}
                                                    </td>
                                                </tr>
                                                <tr :key="i">
                                                    <th>Description</th>
                                                    <td colspan="6">
                                                        {{ itm.Description }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Extra Revenue *
                                        <v-chip class="divs" label value>
                                            {{ totalExtraRev }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col
                                cols="6"
                                style="padding-top: 0px; margin: 0px"
                            >
                                <v-toolbar
                                    color="primary"
                                    dense
                                    height="30"
                                    text-center
                                    dark
                                    >Extra Payroll
                                    <v-spacer></v-spacer>
                                </v-toolbar>

                                <div class="tbl">
                                    <table class="tbl-trs">
                                        <thead>
                                            <tr>
                                                <template
                                                    v-for="(titles,
                                                    i) in transPayHeaders"
                                                >
                                                    <th
                                                        :key="i"
                                                        :width="titles.width"
                                                    >
                                                        {{ titles.text }}
                                                    </th>
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template
                                                v-for="(itm,
                                                i) in extraPayTrans"
                                            >
                                                <tr :key="i">
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.OrderNumber }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{
                                                            itm.TransactionName
                                                        }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Quantity }}
                                                    </td>
                                                    <td
                                                        style="text-align:center"
                                                    >
                                                        {{ itm.Rate }}
                                                    </td>
                                                    <td>
                                                        {{ itm.Amount }}
                                                    </td>
                                                    <td>
                                                        {{ itm.PayId }}
                                                    </td>
                                                </tr>
                                                <tr :key="i">
                                                    <th>Description</th>
                                                    <td colspan="6">
                                                        {{ itm.Description }}
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                                <v-row justify="end">
                                    <v-col cols="12">
                                        Total Extra Payroll *
                                        <v-chip class="divs" label value>
                                            {{ totalExtraPay }}
                                        </v-chip>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-container>
            </v-card>
            <v-dialog
                v-model="$store.state.transacting.dialogAddExt"
                width="600"
            >
                <v-card>
                    <v-toolbar color="secondary" dense>
                        <v-spacer></v-spacer>
                        <v-card-title primary-title style="color:#fff;">
                            Add Extra {{ title }}
                        </v-card-title>
                        <v-spacer></v-spacer>
                        <v-btn
                            dark
                            icon
                            left
                            @click="
                                $store.state.transacting.dialogAddExt = false
                            "
                            ><v-icon>mdi-close</v-icon></v-btn
                        >
                    </v-toolbar>
                    <AddExtraRevenue
                        :Add="params"
                        v-if="$store.state.transacting.dialogAddExt"
                    ></AddExtraRevenue>
                </v-card>
            </v-dialog>

            <CalculateMoq :Add="Drillshift" v-if="$store.state.posting.mod" />

            <v-dialog
                v-model="$store.state.posting.dialog"
                transition="dialog-bottom-transition"
                overlay-color="accent"
                width="1500"
            >
                <OrderData v-if="$store.state.posting.dialog" />
            </v-dialog>
        </v-container>
        <v-dialog
            v-model="$store.state.transacting.dialogRate"
            persistent
            :overlay="false"
            width="1300px"
            transition="dialog-transition"
        >
            <ratesModal
                :dataInfo="rateInfo"
                v-if="$store.state.transacting.dialogRate"
            ></ratesModal>
        </v-dialog>

        <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
    </div>
</template>
<script>
import { mask } from 'vue-the-mask';
import axios from 'axios';
import CalculateMoq from './../Modals/Administration/Transacting/CalculateMoq.vue';
import OrderData from './../Modals/Administration/OrderData.vue';
import ratesModal from '../Modals/Administration/Transacting/RatesModal.vue';
import ConfirmDialogue from './../Modals/ConfirmDialogue.vue';

export default {
    directives: { mask },
    props:['dashboard'],
    components: {
        OrderData,
        CalculateMoq,
        ConfirmDialogue,
        ratesModal
    },
    data: function() {
        return {
            Drillshift: '',
            loadData: false,
            loadProgress: false,
            value: '',
            marginComment: '',
            items: [{ text: 'Totals', icon: 'mdi-star-circle', action: 2 }],
            progress: false,
            products: [],
            btnPayroll: true,
            selectedItem: '',
            btnRevenue: true,
            color: 'purple',
            shifts: [],
            title: null,
            subMenu: 1,
            shift: [],
            orders: [],
            disabled: null,
            revTrans: [],
            payTrans: [],
            textbox: [],
            extraRevTrans: [],
            extraPayTrans: [],
            ShiftDetail: {
                0: {
                    ShiftDetail: '',
                    Yard: '',
                    Trailer: '',
                    Driver: '',
                    Truck: '',
                    ShiftStartTime: '',

                    ShiftEndsTime: '',
                    Shift: '',
                    ShiftDate: ''
                }
            },
            orderHeaders: [
                { text: 'Action', value: 'open', width: '1%' },
                { text: 'L1', value: 'LoadNum', width: '1%' },
                { text: 'L2', value: 'LoadNumOrd', width: '1%' },
                { text: 'Order', value: 'OrderID', width: '5%' },
                { text: 'BOL', value: 'BOL', width: '5%' },
                { text: 'Customer', value: 'Customer', width: '25%' },
                { text: 'Terminal', value: 'Terminal', width: '15%' },
                { text: 'Station', value: 'Station', width: '20%' },
                {
                    text: 'Preload Order#',
                    value: 'PreloadOrderID',
                    width: '5%'
                }
            ],
            transHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '10%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '20%'
                },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' },
                { text: 'InvId', value: 'InvId', width: '5%' }
                //  { text: 'Actions', value: 'Actios', width: '5%' }
            ],
            transPayHeaders: [
                { text: 'Order', value: 'OrderNumber', width: '10%' },
                {
                    text: 'Transaction Type',
                    value: 'TransactionName',
                    width: '20%'
                },
                { text: 'Qty', value: 'Quantity', width: '10%' },
                { text: 'Rate', value: 'Rate', width: '10%' },
                { text: 'Amount', value: 'Amount', width: '10%' },
                { text: 'PayId', value: 'PayId', width: '5%' }
                // { text: 'Actions', value: 'Actios', width: '5%' }
            ]
        };
    },
    watch: {
        '$store.state.transacting.watch': function() {
            if (this.$store.state.transacting.watch == true) {
                this.loadShiftInfo();
            } else {
                console.log('Hola');
            }
        }
    },
    computed: {
        totalRev: function() {
            var list = this.revTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraRev: function() {
            var list = this.extraRevTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalPay: function() {
            var list = this.payTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        totalExtraPay: function() {
            var list = this.extraPayTrans;
            var sum = 0;
            for (var rev in list) {
                sum += list[rev].Amount;
            }
            sum = Math.round((sum + Number.EPSILON) * 100) / 100;
            return sum;
        },
        net: function() {
            var net =
                this.totalRev +
                this.totalExtraRev +
                (this.totalPay + this.totalExtraPay);
            return Math.round((net + Number.EPSILON) * 100) / 100;
        },
        margin: function() {
            var margin = this.net / (this.totalRev + this.totalExtraRev);
            return Math.round((margin + Number.EPSILON) * 100) / 100;
        }
    },
    mounted() {
        this.loadShiftInfo();
    },
    methods: {
        saveComment: function() {
            var str = this.$store;
            str.state.isLoading = true;
            var params = {
                MarginAnalysis: this.marginComment
            };
            axios
                .put('shift-detail/' + this.Drillshift, params)
                .then(response => {
                    console.log(response.data);
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        checks: function() {
            alert(this.ShiftDetail[0].NoRate);
        },
        loadOrderDetails: function(orderID) {
            var str = this.$store;
            this.products = [];
            this.progress = true;
            axios
                .get('order-detail/order/' + orderID)
                .then(response => {
                    console.log(response.data.data);
                    this.products = response.data.data;
                    console.log(this.products);

                    this.progress = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }

                    this.progress = false;
                });
        },
        loadShiftInfo: function() {
            if (this.$store.state.analytics.title == 'View By Shift') {
                this.Drillshift = this.$store.state.analytics.itm.ShiftDetail;
            } else {
                this.Drillshift = this.$store.state.analytics.subItem.ShiftDetail;
            }
            console.log(this.Drillshift);
            this.$store.state.isLoading = true;
            this.loadOrders();
            this.loadRev();
            this.loadShift();
            this.loadExtraRev();
            this.loadPay();
            this.loadExtraPay();
            this.btnRevenue = true;
            this.btnPayroll = true;
            this.$store.state.transacting.watch = false;
        },
        async onSaveShift() {
            const ok = await this.$refs.confirmDialogue.show({
                title: 'You are about to finalize Shift #' + this.Drillshift,
                message: 'Are you sure?',
                okButton: 'Yes',
                cancelButton: 'No'
            });
            // If you throw an error, the method will terminate here unless you surround it wil try/catch
            if (ok) {
                this.finalizeShift(1);
            }
        },
        loadShift: async function() {
            var str = this.$store;
            console.log(this.value);
            this.loadProgress = true;
            try {
                let response = await axios.get(
                    'shift-detail/resource/' + this.Drillshift,
                    {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    }
                );
                this.ShiftDetail = response.data;
                console.log(this.ShiftDetail);
                this.marginComment = this.ShiftDetail[0].MarginAnalysis;
                if (this.ShiftDetail[0].Finalize == 1) {
                    this.disabled = true;
                } else {
                    this.disabled = false;
                }
                this.loadProgress = false;
                this.loadData = true;
                console.log(this.ShiftDetail);
            } catch (error) {
                console.log(error);
                str.dispatch('setSnackbar', {
                    color: 'error',
                    text: 'Shift No Found'
                });
                this.loadProgress = false;
                this.loadData = false;
            }
            this.loadProgress = false;
        },
        loadOrders: function() {
            console.log('loadOrders');
            axios
                .get('order/shift/' + this.Drillshift)
                .then(response => {
                    this.orders = response.data;
                    console.log(this.orders);
                    if (this.orders.length > 0) {
                        this.btnRevenue = false;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadRev: function() {
            axios
                .get('shift-analytics/revenue/' + this.Drillshift)
                .then(response => {
                    this.revTrans = response.data.data;

                    this.btnPayroll = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        openRates: function(itm) {
            this.rateInfo = itm;
            this.$store.state.transacting.dialogRate = true;
        },
        finalizeShift: function(itm) {
            var parms = {
                Finalize: itm
            };
            axios
                .put('shift-detail/' + this.Drillshift, parms)
                .then(response => {
                    console.log(response.data);
                    this.insertDisp(itm);
                    this.loadShiftInfo();
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        insertDisp: function() {
            var parms = {
                Type: 'Finalize',
                Shift: this.Drillshift
            };
            axios
                .post('disp-order/insert', parms)
                .then(response => {
                    console.log(response.data);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraRev: function() {
            axios
                .get('shift-analytics/extra-revenue/' + this.Drillshift)
                .then(response => {
                    this.extraRevTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadPay: function() {
            axios
                .get('shift-analytics/payroll/' + this.Drillshift)
                .then(response => {
                    this.payTrans = response.data.data;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        loadExtraPay: function() {
            axios
                .get('shift-analytics/extra-payroll/' + this.Drillshift)
                .then(response => {
                    this.extraPayTrans = response.data.data;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        transactRev: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('transaction/transact-rev/' + this.Drillshift, '')
                .then(response => {
                    console.log(response.data);
                    this.loadRev();
                    this.loadExtraRev();
                    this.btnPayroll = false;

                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        transactPay: function() {
            this.$store.state.isLoading = true;
            var str = this.$store;
            axios
                .post('transaction/transact-pay/' + this.Drillshift, '')
                .then(response => {
                    console.log(response.data);
                    this.loadPay();
                    this.loadExtraPay();
                    this.$store.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    if (error.response.status === 403) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text:
                                'You do not have the permission to use this function.'
                        });
                    }
                    if (error.response.status === 500) {
                        str.dispatch('setSnackbar', {
                            color: 'error',
                            text: 'An error has ocurred, please try again.'
                        });
                    }
                });
        },
        deleteItem: function(item) {
            this.$store.state.isLoading = true;
            const index = item.TranId;
            var r = confirm('Are you sure you want to delete?');
            var str = this.$store;
            if (r) {
                axios
                    .delete('transaction/' + index, {
                        headers: {
                            Authorization: 'Bearer ' + this.$store.state.token
                        }
                    })
                    // eslint-disable-next-line no-unused-vars
                    .then(response => {
                        console.log(response);
                        this.loadShiftInfo();
                    })
                    .catch(function(error) {
                        console.log(error);
                        if (error.response.status === 403) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text:
                                    'You do not have the permission to use this function.'
                            });
                        }
                        if (error.response.status === 500) {
                            str.dispatch('setSnackbar', {
                                color: 'error',
                                text: 'An error has ocurred, please try again.'
                            });
                        }
                    });
                this.$store.state.isLoading = false;
            } else {
                confirm('Canceled');
            }
        },
        openModalOrder: function(item) {
            this.$store.state.orderInfo.orderId = item.OrderID;
            console.log(item);
            this.$store.state.posting.dialog = true;
        },
        saveMore: function(itm) {
            console.log(itm);
            var parms = {
                AdmComments: itm.AdmComments,
                'No Rate': itm.NoRate,

                'Short Load': itm.ShortLoad,
                Other: itm.Other
            };
            console.log(parms);
            axios
                .put('shift-detail/' + itm.ShiftDetail, parms)
                .then(response => {
                    console.log(response);
                    this.$store.dispatch('setSnackbar', {
                        color: 'success',
                        text: 'saved successfully'
                    });
                })
                .catch(function(error) {
                    console.log(error);
                });
        }
    }
};
</script>
<style>
.tableTrasac tr > th {
    background: #01579b;
    color: #fff;
    text-align: center;
}
td {
    height: 0px;
}
td:hover {
    background: none;
}
</style>
